import { _t } from '../base.js'

export function initStep2() {
    if ($('.id--16').length) {
        step2ContentLoaded()
    }
}

function moveStep2Elements() {
    const orderSummary = document.querySelector('.order-summary')
    const orderSummaryInner = document.querySelector('.order-summary-inner')
    const nextStep = document.querySelector('.next-step')

    if (orderSummary && orderSummaryInner && nextStep) {
        orderSummary.insertBefore(nextStep, orderSummaryInner.nextSibling)
    }
}

function renameStep2Texts() {
    const orderButtonText = document.querySelector('.next-step-forward .order-button-text')

    if (orderButtonText) {
        orderButtonText.textContent = _t('orderInfo')
    }
}

// function addItemIdStep2() {
//     document.querySelectorAll('.order-summary-item[data-micro-sku]').forEach((summaryItem) => {
//         const skuValue = summaryItem.getAttribute('data-micro-sku')

//         if (skuValue) {
//             const skuDiv = document.createElement('div')
//             skuDiv.classList.add('cart-item-id')
//             skuDiv.textContent = `Kód produktu: ${skuValue}`

//             const anchor = summaryItem.querySelector('div > a')

//             if (anchor) {
//                 anchor.insertAdjacentElement('afterend', skuDiv)
//             }
//         }
//     })
// }

function step2ContentLoaded() {
    moveStep2Elements()
    renameStep2Texts()
    // addItemIdStep2()
    console.log('cart 2')
}
